const ListingDeliveryStatus = Object.freeze({
  Delivered: {
    name: 'Delivered',
    value: 'delivered',
    color: 'success-lightest',
  },
  Undelivered: {
    name: 'Undelivered',
    value: 'undelivered',
    color: 'danger-lightest',
  },
  Scheduled: {
    name: 'Scheduled',
    value: 'scheduled',
    color: 'warning-lightest',
  },
})

export default ListingDeliveryStatus
